"use client";

import { useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import CategoryDropdown from "./category-dropdown";
import Search from "icons/Search";

export default function SearchInputWithCategory({ categories }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  if (!categories || !categories.length) return null;

  const handleEnter = async (event) => {
    if (event.key === "Enter" && search) {
      setLoading(true);
      try {
        const params = new URLSearchParams(searchParams);
        const selected = searchParams.get("category") || "product";
        params.set("q", search);
        params.set("category", selected);
        router.push(`/products/search?${params.toString()}`);
      } finally {
        setTimeout(() => setLoading(false), 2000);
      }
    }
  };

  const INPUT_PROPS = {
    sx: {
      border: 0,
      height: 46,
      padding: 0,
      borderRadius: 2,
      overflow: "hidden",
      backgroundColor: "grey.200",
      "& .MuiOutlinedInput-notchedOutline": {
        border: 1,
        borderColor: "grey.300",
      },
    },
    startAdornment: (
      <Box
        mr={2}
        px={2}
        display="grid"
        alignItems="center"
        justifyContent="center"
        borderRight="1px solid"
        borderColor="grey.400"
        minWidth={40}
      >
        {loading ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <Search
            sx={{
              fontSize: 17,
              color: "grey.600",
            }}
          />
        )}
      </Box>
    ),
    endAdornment: <CategoryDropdown categories={categories} />,
  };

  return (
    <Box position="relative" flex="1 1 0" maxWidth="670px" mx="auto">
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Buscar..."
        value={search}
        onKeyDown={handleEnter}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={INPUT_PROPS}
      />
    </Box>
  );
}
